<template>
  <el-dialog title="Change Rider Status" :visible.sync="setShow" width="30%">
    <el-form :model="form" label-position="top">
      <el-row type="flex">
        <el-col :span="24">
          <el-form-item
            label="Select new status"
            prop="status"
            :rules="validateFigure()"
          >
            <el-radio-group v-model="form.status">
              <el-radio :label="'active'">Active</el-radio>
              <el-radio :label="'inactive'">Inactive</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button plain @click="setShow = false">Cancel</el-button>
      <el-button
        type="primary"
        :loading="changing"
        :disabled="rider.status === form.status"
        @click="change"
        >Change</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import riders from "@/requests/marketplace-logistics/riders";

export default {
  name: "RiderStatus",
  props: {
    show: {
      type: Boolean,
      default: true,
    },
    rider: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      changing: false,
      form: {
        status: "",
      },
    };
  },
  computed: {
    setShow: {
      get() {
        return this.show;
      },
      set(value) {
        this.$emit("update:show", value);
      },
    },
  },
  watch: {
    show() {
      if (this.show) {
        this.form.status = this.rider.status;
      }
    },
  },
  methods: {
    change() {
      this.changing = true;

      const payload = {
        status: this.form.status,
      };

      riders
        .update(this.rider.uuid, payload)
        .then((response) => {
          const { status, message } = response.data;
          if (status) {
            this.$message.success(message);
            this.$emit("success");
            this.close();
          }
        })
        .catch((error) => {
          const errorMessage = error.response.data;
          if (errorMessage.errors) {
            const errorKeys = Object.keys(errorMessage.errors);
            this.$message.error(errorMessage.errors[errorKeys[0]].join(""));
          } else {
            this.$message.error(errorMessage.message);
          }
        })
        .finally(() => {
          this.changing = false;
        });
    },
    close() {
      this.setShow = false;
      this.changing = false;
      this.form.status = "";
    },
  },
};
</script>

<style lang="scss" scoped></style>
